/**
 * Theme Store
 *
 * Manages theme selection with persistence to localStorage.
 * Theme preference is stored globally (not per-project).
 */

import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { ThemeName, applyTheme } from '@/styles/themes';

interface ThemeState {
  theme: ThemeName;
  setTheme: (theme: ThemeName) => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      theme: 'dark',
      setTheme: (theme: ThemeName) => {
        applyTheme(theme);
        set({ theme });
      },
    }),
    {
      name: 'nodebeat-theme',
      version: 1,
    }
  )
);

/**
 * Initialize theme on app load
 * This should be called once when the app starts
 */
export function initializeTheme(): void {
  const theme = useThemeStore.getState().theme;
  applyTheme(theme);
}
